// extracted by mini-css-extract-plugin
export default {"imageLink":"ImageLink_imageLink__sXNan","iconContainer":"ImageLink_iconContainer__doWEY","icon":"ImageLink_icon__7idCJ"};